<script setup>

    import { ref, watchEffect } from 'vue';
    import { getFromAPI, getFullUrl } from '../../functionCollection.js';

    const props = defineProps(['fetchUrl', 'userNumber']);
    defineEmits(['switch-to-edit']); // makes parent component UserData switch to edit component UserDataEdit

    const userInfo = ref(null);

    // get user info from API.
    watchEffect(async () => {
        const url = getFullUrl(props.fetchUrl, props.userNumber);
        userInfo.value = await getFromAPI(url);
    });

</script>

<template>
    <h3>Meine Daten</h3>
    <div class="well" v-if="userInfo">
        <div class="row">
            <div class="col">
                <p>
                    {{ userInfo.Name1 }}<br>
                    {{ userInfo.Name2 }}<br>
                    {{ userInfo.Strasse }}<br>
                    {{ userInfo.PLZ }} {{ userInfo.Ort }}<br>
                    {{ userInfo.Land }}<br>
                </p>
            </div>
            <div class="col">
                <p>
                    {{ userInfo.Email }}<br>
                    {{ userInfo.Telefon1 }}<br>
                    {{ userInfo.Telefon2 }}<br>
                </p>
                <p><strong>Geburtstag:</strong> {{ userInfo.Geburtsdatum }}</p>
            </div>
        </div>
        <div class="table-footer right">
            <button class="btn btn-link footer-button" @click="$emit('switch-to-edit')">
                Bearbeiten
                <i class="fas fa-lg fa-pencil-alt"></i>
            </button>
        </div>
    </div>
</template>
